<template>
    <div class="uk-padding uk-background-muted" >
        <div class="uk-container">
            <h1>{{ this.$route.name}}</h1>

        </div>
    </div>
</template>

<script>
    export default {
        name: "pageheading"
    }
</script>

<style scoped>
    @media screen and (max-width:600px){


        h1{
            font-size: 1.2em !important;
        }


    }
</style>
